import APIService from '../api.service';

export const All = (params) => APIService.get('/v01/warehouse-orders', {
  params: {
    per_page: params.perPage,
    page: params.page,
    keyword: params.keyword,
    status: params.status,
    source_warehouse_id: params.source_warehouse_id,
    destination_warehouse_id: params.destination_warehouse_id,
    date: params.date,
  },
});

export const Create = (body) => APIService.post('/v01/warehouse-orders', body);
export const Get = (id) => APIService.get(`/v01/warehouse-orders/${id}`);
export const Update = (id, body) => APIService.put(`/v01/warehouse-orders/${id}`, body);
export const Confirm = (id) => APIService.post(`/v01/warehouse-orders/${id}/confirm`);
export const Cancel = (id) => APIService.post(`/v01/warehouse-orders/${id}/cancel`);
export const WarehouseOptions = () => APIService.get('/v01/warehouse-orders/warehouse-options');
export const MainWarehouses = () => APIService.get('/v01/warehouse-orders/main-warehouses');
export const SearchProducts = (params = {}, config = {}) =>
  APIService.get('/v01/warehouse-orders/products/search', {
    params: {
      keyword: params.keyword ?? params.q,
      page: params.page,
      per_page: params.perPage ?? params.per_page,
    },
    ...config,
  });

export const StockAvailability = (params) =>
  APIService.get('/v01/warehouse-orders/stock-availability', {
    params: {
      warehouse_id: params.warehouse_id,
      product_id: params.product_id,
      product_type: params.product_type,
    },
  });

export const SaveTransfer = (id, body) => APIService.put(`/v01/warehouse-orders/${id}/transfer`, body);
export const MarkTransferred = (id) => APIService.post(`/v01/warehouse-orders/${id}/transfer/mark-transferred`);
export const CancelTransfer = (id) => APIService.post(`/v01/warehouse-orders/${id}/transfer/cancel`);

export const SaveReceive = (id, body) => APIService.put(`/v01/warehouse-orders/${id}/receive`, body);
export const ConfirmReceive = (id) => APIService.post(`/v01/warehouse-orders/${id}/receive/confirm`);

const WarehouseOrderService = {
  All,
  Create,
  Get,
  Update,
  Confirm,
  Cancel,
  WarehouseOptions,
  MainWarehouses,
  SearchProducts,
  StockAvailability,
  SaveTransfer,
  MarkTransferred,
  CancelTransfer,
  SaveReceive,
  ConfirmReceive,
};
export default WarehouseOrderService;
